/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { PaymentMethodResponse } from "./PaymentMethodResponse";
import * as t from "io-ts";

/**
 * Payment methods response
 */

// required attributes
const PaymentMethodsResponseR = t.interface({});

// optional attributes
const PaymentMethodsResponseO = t.partial({
  paymentMethods: t.readonlyArray(
    PaymentMethodResponse,
    "array of PaymentMethodResponse"
  )
});

export const PaymentMethodsResponse = t.intersection(
  [PaymentMethodsResponseR, PaymentMethodsResponseO],
  "PaymentMethodsResponse"
);

export type PaymentMethodsResponse = t.TypeOf<typeof PaymentMethodsResponse>;
